/**
 * Electricity Sources Grid Component
 * Icon-based grid showing different electricity sources
 * for heat pump appendix
 */

interface ElectricitySourcesGridProps {
  width?: number;
  height?: number;
}

export function ElectricitySourcesGrid({ width = 560, height = 200 }: ElectricitySourcesGridProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 560 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', margin: '0 auto' }}
    >
      {/* Wind / Solar - Left */}
      <g>
        {/* Wind turbine icon */}
        <circle cx="90" cy="50" r="8" fill="#10b981" />
        <rect x="86" y="58" width="8" height="40" fill="#64748b" />
        <path d="M 90 50 L 75 30" stroke="#10b981" strokeWidth="3" strokeLinecap="round" />
        <path d="M 90 50 L 105 35" stroke="#10b981" strokeWidth="3" strokeLinecap="round" />
        <path d="M 90 50 L 90 25" stroke="#10b981" strokeWidth="3" strokeLinecap="round" />
        
        {/* Sun icon */}
        <circle cx="120" cy="50" r="10" fill="#fbbf24" />
        <path d="M 120 30 L 120 35" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" />
        <path d="M 120 65 L 120 70" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" />
        <path d="M 100 50 L 105 50" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" />
        <path d="M 135 50 L 140 50" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" />
        
        <text x="105" y="120" textAnchor="middle" fontSize="14" fontWeight="600" fill="#1e293b">
          Wind / solar
        </text>
        <text x="105" y="145" textAnchor="middle" fontSize="12" fill="#64748b" style={{ maxWidth: '160px' }}>
          Very low losses before
        </text>
        <text x="105" y="160" textAnchor="middle" fontSize="12" fill="#64748b">
          it reaches your home
        </text>
      </g>

      {/* Nuclear - Center */}
      <g transform="translate(190, 0)">
        {/* Nuclear icon */}
        <circle cx="90" cy="50" r="12" fill="#3b82f6" />
        <circle cx="90" cy="50" r="6" fill="#1e40af" />
        <path d="M 90 38 L 90 28" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
        <path d="M 90 62 L 90 72" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
        <path d="M 78 50 L 68 50" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
        <path d="M 102 50 L 112 50" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
        
        <text x="90" y="120" textAnchor="middle" fontSize="14" fontWeight="600" fill="#1e293b">
          Nuclear
        </text>
        <text x="90" y="145" textAnchor="middle" fontSize="12" fill="#64748b">
          High output, low carbon,
        </text>
        <text x="90" y="160" textAnchor="middle" fontSize="12" fill="#64748b">
          stable supply
        </text>
      </g>

      {/* Gas-fired generation - Right */}
      <g transform="translate(370, 0)">
        {/* Gas flame icon */}
        <path d="M 90 70 Q 85 60, 90 50 Q 95 40, 90 30 Q 88 35, 85 40 Q 82 45, 85 50 Q 88 55, 85 60 Q 83 65, 85 70 Z" fill="#f59e0b" />
        <path d="M 90 70 Q 93 65, 92 60 Q 91 55, 92 50 Q 93 45, 90 40" fill="#fbbf24" />
        
        <text x="90" y="120" textAnchor="middle" fontSize="14" fontWeight="600" fill="#1e293b">
          Gas-fired generation
        </text>
        <text x="90" y="145" textAnchor="middle" fontSize="12" fill="#64748b">
          Extra losses occur before
        </text>
        <text x="90" y="160" textAnchor="middle" fontSize="12" fill="#64748b">
          electricity reaches your home
        </text>
      </g>
    </svg>
  );
}
